import {useEffect, useState} from 'react';
import {useIntl} from 'react-intl';
import useSWR from 'swr';

import {getAllWorksTags} from '../scripts/libs/get-all-work-tags';
import getLocalizedText from '../scripts/libs/get-localized-text';

import {FilterListEntry} from '../../../shared/types/filter';
import {MultiLingualTags, Tag, TagsList} from '../../../shared/types/work';

// Holds all the tag filter entries and multilingual tags
const useTags = (): {
  tags: MultiLingualTags | null;
  tagsFilterEntries: Array<FilterListEntry<Tag>>;
} => {
  const {locale} = useIntl();

  const [tagsFilterEntries, setTagsFilterEntries] = useState<
    Array<FilterListEntry<Tag>>
  >([]);

  const [tags, setTags] = useState<MultiLingualTags | null>(null);

  const {data, error} = useSWR('works');

  // Set multilingual tags and tagsFilterEntries
  useEffect(() => {
    if (!error && data) {
      // Set new Multilingual tags
      const newTags = getAllWorksTags(data);

      if (!newTags) {
        return;
      }

      setTags(newTags);

      // Set new tagsFilterEntries
      const germanTags = newTags.map(
        newTag => newTag.de
      ) as unknown as TagsList;

      const newTagsFilterEntries: Array<FilterListEntry<Tag>> = newTags
        .filter((newTag, index) => germanTags.indexOf(newTag.de) === index)
        .map(tag => ({
          label: getLocalizedText(tag, locale),
          value: tag.de
        }));

      setTagsFilterEntries(newTagsFilterEntries);
    }
  }, [data, locale]);

  return {tags, tagsFilterEntries};
};

export default useTags;
